function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["dataSource", "params", "columns", "search", "pagination", "actionRef", "formRef", "layout", "formProps", "isAutoBackPage", "formItemsStyle", "toolBar", "isFirstToRequest", "size", "isAutoComputeFormLine", "isParamsChangeClearPage", "rowKey", "renderOptionBar", "columnsSettings", "headerItemRender", "rowItemRender", "beforeSearchSubmit", "onReset", "onSubmit", "request", "postData", "renderFooter", "inTableParamsChange", "tableInitParams", "onChangeColumns", "needScroll"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @ File:
 * @ Description:
 * @ Author: cqh
 * @ Create Time: 2023-02-15 18:01:35
 * @ Modified by: cqh
 * @ Modified time: 2024-10-14 17:53:44
 */
import React, { useEffect, useState, useRef, useImperativeHandle, useContext } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { Table, Form, ConfigProvider } from 'antd';
import { useDeepCompareEffect } from 'ahooks';
import zhCN from 'antd/es/locale/zh_CN';
import { compose, usingColSearchTransForm, diffChange, getObjectKey, backPageData, transFromObjectKey, moveHide, getRenderOptionBar, composeColum } from "./tools";
import { Provider } from "./context";
import { defaultFormProps, defaultSearchConfig, superTableWarpId } from "./constants";
import "./index.module.less";
import { GenerAtorFrom, setSuperTableProps } from "./utils/generator";
import SuperContext from "../SuperProvider";
import ToolBar from "./components/ToolBar";
import { uniqBy } from 'lodash';

/**
 * 请求id  用来方式 竞态关系的
 */
var raceId = 0;

/**
 * 页脚的默认配置
 */
var defaultPagination = {
  pageSize: 10,
  current: 1,
  showQuickJumper: true,
  showSizeChanger: true,
  disabled: false,
  showTotal: function showTotal(t) {
    return "\u603B\u5171".concat(t, "\u6761");
  },
  total: 0
};

/**
 * @ dataSource: 数据源
 * @ params: 接口调用的额外参数 发生改变的时候会重新render
 * @ postData: 拿到数据后做的转换操作
 * @ request: 请求方法
 * @ columns: 表头 用法同proTable一致  目前能支持的自动生成的type  ['text','select','textarea','date','progress','switch']
 * @ search: 查询条件配置 searchText 搜索按钮的文字 resetText重置按钮的文字
 * @ pagination: 页脚的配置 同antd  需要注意的是默认的配置是onchange的逻辑的
 * @ beforeSearchSubmit: 查询前的操作 可以对数据进行一层转换
 * @ actionRef: table的ref 目前就实现了 reload 有其他的需要可以直接找我加（doge）
 * @ formRef: 表单的ref 有getFieldsValue和setFieldsValue 等等的方法可以直接使用 和antd form 一致
 * @ layout: 默认是inline
 * @ onSubmit: 提交表单的回调
 * @ onReset: 重置表单的回调
 * @ renderFooter : 表单的底部的配置
 * @ inTableParamsChange : 获取request的参数的回调 包含了current 和一些入参
 * @ tableInitParams : 携带session的参数在请求一次数据  初始化得时候给form
/**
 *
 *
 * @param {SuperTypeProps} props
 * @return {*}
 */
function SuperTable(props) {
  var _renderOptionBar$top, _renderOptionBar$cent, _renderOptionBar$bott;
  var dataSource = props.dataSource,
    params = props.params,
    _props$columns = props.columns,
    columns = _props$columns === void 0 ? [] : _props$columns,
    _props$search = props.search,
    search = _props$search === void 0 ? {} : _props$search,
    _props$pagination = props.pagination,
    pagination = _props$pagination === void 0 ? {} : _props$pagination,
    _props$actionRef = props.actionRef,
    actionRef = _props$actionRef === void 0 ? {
      current: {}
    } : _props$actionRef,
    _props$formRef = props.formRef,
    formRef = _props$formRef === void 0 ? {
      current: {}
    } : _props$formRef,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'inline' : _props$layout,
    _props$formProps = props.formProps,
    formProps = _props$formProps === void 0 ? defaultFormProps : _props$formProps,
    _props$isAutoBackPage = props.isAutoBackPage,
    isAutoBackPage = _props$isAutoBackPage === void 0 ? true : _props$isAutoBackPage,
    formItemsStyle = props.formItemsStyle,
    toolBar = props.toolBar,
    _props$isFirstToReque = props.isFirstToRequest,
    isFirstToRequest = _props$isFirstToReque === void 0 ? true : _props$isFirstToReque,
    _props$size = props.size,
    size = _props$size === void 0 ? 'large' : _props$size,
    _props$isAutoComputeF = props.isAutoComputeFormLine,
    isAutoComputeFormLine = _props$isAutoComputeF === void 0 ? true : _props$isAutoComputeF,
    _props$isParamsChange = props.isParamsChangeClearPage,
    isParamsChangeClearPage = _props$isParamsChange === void 0 ? true : _props$isParamsChange,
    rowKey = props.rowKey,
    renderOptionBar = props.renderOptionBar,
    columnsSettings = props.columnsSettings,
    headerItemRender = props.headerItemRender,
    rowItemRender = props.rowItemRender,
    beforeSearchSubmit = props.beforeSearchSubmit,
    _props$onReset = props.onReset,
    onReset = _props$onReset === void 0 ? function (v) {
      return v;
    } : _props$onReset,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? function (v) {
      return v;
    } : _props$onSubmit,
    request = props.request,
    postData = props.postData,
    renderFooter = props.renderFooter,
    _props$inTableParamsC = props.inTableParamsChange,
    inTableParamsChange = _props$inTableParamsC === void 0 ? function (v) {
      return v;
    } : _props$inTableParamsC,
    tableInitParams = props.tableInitParams,
    onChangeColumns = props.onChangeColumns,
    _props$needScroll = props.needScroll,
    needScroll = _props$needScroll === void 0 ? true : _props$needScroll,
    reset = _objectWithoutProperties(props, _excluded);
  setSuperTableProps(props);
  var contextData = useContext(SuperContext);
  var tableRef = useRef(null);

  // 排序之后的columns
  var sortedColumns = composeColum(columns) || [];
  // 表格当前显示的columns
  var _useState = useState(moveHide(sortedColumns)),
    _useState2 = _slicedToArray(_useState, 2),
    tableColumns = _useState2[0],
    setTableColumns = _useState2[1];

  /** 不做缓存的 pageData 对象数据 */
  var noCatchPageData = {
    onChange: function onChange(page, size) {
      var _tableRef$current;
      /**  页码改变时, 滚动条置顶  */
      if (needScroll) {
        var _window;
        (_window = window) === null || _window === void 0 || _window.scrollTo(0, 0);
      }
      if (tableRef !== null && tableRef !== void 0 && (_tableRef$current = tableRef.current) !== null && _tableRef$current !== void 0 && (_tableRef$current = _tableRef$current.getElementsByClassName('ant-table-content')) !== null && _tableRef$current !== void 0 && _tableRef$current[0]) {
        tableRef.current.getElementsByClassName('ant-table-content')[0].scrollLeft = 0;
      }
      setPageData(page, size);
      doServerAddSearch();
    }
  };

  /**
   * 数据源
   */
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    _dataSource = _useState4[0],
    setDataSource = _useState4[1];
  /**
   * form 实例
   */
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  /**
   * pageData  这里对默认的 和自定义的进行了一层合并
   */
  var pageData = useRef(_objectSpread(_objectSpread({}, defaultPagination), pagination));
  /**
   * 上一次的params  来进行比较和更新的
   */
  var prvParams = useRef(params);

  /**
   * 获取数据 并且带上搜索框的参数
   */
  function doServerAddSearch(_x) {
    return _doServerAddSearch.apply(this, arguments);
  }
  /**
   *  请求接口并且重置 table
   */
  function _doServerAddSearch() {
    _doServerAddSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(doServerAddSearchParams) {
      var formValue, result;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            formValue = _objectSpread(_objectSpread({}, form.getFieldsValue(true)), doServerAddSearchParams || {});
            _context3.next = 3;
            return doGetServerData(formValue);
          case 3:
            result = _context3.sent;
            onSubmit(formValue);
            return _context3.abrupt("return", result);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _doServerAddSearch.apply(this, arguments);
  }
  function doServerAddSearchAndResetTable() {
    return _doServerAddSearchAndResetTable.apply(this, arguments);
  }
  /**
   * 获取数据 并且重置搜索框和表格的参数
   */
  function _doServerAddSearchAndResetTable() {
    _doServerAddSearchAndResetTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var formValue, result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            resetTableData();
            formValue = form.getFieldsValue(true);
            _context4.next = 4;
            return doGetServerData(formValue);
          case 4:
            result = _context4.sent;
            onSubmit(formValue);
            return _context4.abrupt("return", result);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _doServerAddSearchAndResetTable.apply(this, arguments);
  }
  function doServerResetSearch() {
    return _doServerResetSearch.apply(this, arguments);
  }
  /**
   * 重置table的数据
   */
  function _doServerResetSearch() {
    _doServerResetSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var result;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            resetTableData();
            _context5.next = 3;
            return doGetServerData((form.resetFields(), form.getFieldsValue(true)));
          case 3:
            result = _context5.sent;
            onReset(_objectSpread({}, pageData.current));
            return _context5.abrupt("return", result);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _doServerResetSearch.apply(this, arguments);
  }
  function resetTableData() {
    // pageSize不重置
    setPageData(1, pageData.current.pageSize);
  }
  var getTableInfo = function getTableInfo() {
    return {
      pageData: pageData.current,
      dataSource: getDataSource(),
      params: params,
      rowKey: rowKey,
      columns: tableColumns
    };
  };
  /**
   * 给外层actionRef 绑定方法
   */
  useImperativeHandle(actionRef, function () {
    return {
      reload: function () {
        var _reload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reloadParams) {
          var result;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return doServerAddSearch(reloadParams);
              case 2:
                result = _context.sent;
                return _context.abrupt("return", result);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function reload(_x2) {
          return _reload.apply(this, arguments);
        }
        return reload;
      }(),
      changePage: function () {
        var _changePage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(page, size) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                setPageData(page, size);
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function changePage(_x3, _x4) {
          return _changePage.apply(this, arguments);
        }
        return changePage;
      }(),
      getTableInfo: getTableInfo
    };
  });
  /**
   * 暴露form的操作方法
   */
  useImperativeHandle(formRef, function () {
    return form || {};
  });

  /**
   * context 上下文要使用的数据
   */
  var initState = {
    search: {
      getData: function getData() {
        return doServerAddSearchAndResetTable();
      },
      resetData: function resetData() {
        return doServerResetSearch();
      }
    },
    searchConfig: _objectSpread(_objectSpread({}, defaultSearchConfig), search),
    layout: layout,
    formProps: formProps,
    formItemsStyle: formItemsStyle,
    isAutoComputeFormLine: isAutoComputeFormLine
  };

  /** 请求数据  */
  useEffect(function () {
    var sessionParams = (tableInitParams === null || tableInitParams === void 0 ? void 0 : tableInitParams()) || {};
    var sessionLength = Object.keys(sessionParams).length;
    sessionLength && form.setFieldsValue(sessionParams);

    // 第一次是否需要 table来请求
    isFirstToRequest && doServerAddSearch();
    if (!rowKey) {}
  }, []);
  var handleSetTableColumns = function handleSetTableColumns(newTableColumns) {
    var _tableColumns = _toConsumableArray(newTableColumns);
    if (toolBar) {
      _tableColumns.push({
        width: 100,
        dataIndex: 'toolBar',
        fixed: 'right',
        title: /*#__PURE__*/React.createElement(ToolBar, {
          tableColumns: newTableColumns,
          setTableColumns: handleSetTableColumns,
          columnsSettings: columnsSettings,
          onChangeColumns: onChangeColumns
        })
      });
    }
    setTableColumns(uniqBy(moveHide(_tableColumns), 'key'));
  };

  // 当传进来的columns变化的时候，修改operateColumns和tableColumns
  useDeepCompareEffect(function () {
    var _tableColumns = composeColum(columns);
    /** 第一次进来后处理col 并且监听更新 刷新内部状态  */
    if (toolBar) {
      _tableColumns.push({
        width: 100,
        dataIndex: 'toolBar',
        fixed: 'right',
        title: /*#__PURE__*/React.createElement(ToolBar, {
          tableColumns: composeColum(columns),
          columnsSettings: columnsSettings,
          setTableColumns: handleSetTableColumns,
          onChangeColumns: onChangeColumns
        })
      });
    }
    setTableColumns(moveHide(_tableColumns));
  }, [toolBar, columns]);

  /**记录params的更新 */
  useEffect(function () {
    /*
        如果当前的这一次params  不等于上一次的params
        就表示需要更新
    */
    if (diffChange(prvParams.current, params)) {
      isParamsChangeClearPage && setPageData(1, pageData.current.pageSize);
      doServerAddSearch();
      prvParams.current = params;
    }
    prvParams.current = params;
  });

  /** 请求函数 */
  function doGetServerData(searchParams) {
    return new Promise(function (resolve, reject) {
      /*
        处理竞态关系
       */
      var nowId = ++raceId;
      /*
        对参数做处理 使用beforeSearchSubmit
       */
      var lastParams = compose([beforeSearchSubmit])(_objectSpread(_objectSpread(_objectSpread({}, searchParams), params), transFromObjectKey(getObjectKey(pageData.current, ['pageSize', 'current']), 'current', 'pageNo')));
      /**  回调函数   */
      inTableParamsChange === null || inTableParamsChange === void 0 || inTableParamsChange(lastParams);
      /*
        使用对应的col里面的 transfrom 处理数据
       */
      usingColSearchTransForm(lastParams, columns);
      var _request = Promise.resolve(request === null || request === void 0 ? void 0 : request(lastParams));
      _request.then(function (result) {
        /*
          如果当前闭包里面存储的 id  和全局的对不上 说明我不是最后一个发起的
          也就是 一般情况下 会直接使用 最后一起调用请求的数据
         */
        if (nowId !== raceId) return;
        var _ref = compose([postData])(result) || {},
          data = _ref.data,
          totalCount = _ref.totalCount,
          _ref$success = _ref.success,
          success = _ref$success === void 0 ? true : _ref$success;
        if (success) {
          // 如果成功之后 再去进行更新数据
          unstable_batchedUpdates(function () {
            // 批处理更新 防止多次render
            pageData.current.total = totalCount;
            setDataSource(data);
            // 自动退页码逻辑
            if (backPageData({
              length: data === null || data === void 0 ? void 0 : data.length,
              pageNo: pageData.current.current,
              flag: isAutoBackPage
            })) {
              setPageData(pageData.current.current - 1, pageData.current.pageSize);
              return doGetServerData(searchParams);
            } else {
              resolve(result);
            }
          });
        }
        return result;
      }, reject);
    });
  }

  /**
   *  page 和 size的改变  使用ref 作为逃生舱 不对页面进行render
   * @param page
   * @param size
   */
  function setPageData(page, size) {
    pageData.current.current = page || pageData.current.defaultCurrent || 1;
    pageData.current.pageSize = size || pageData.current.defaultPageSize || 10;
  }

  /**
   * 是否展示 间隔 在 处理 renderOptionBar 之前
   */
  var isShowSpace = [renderOptionBar, toolBar].some(Boolean);

  /**
   * renderOptionBar 的额外处理
   */
  var _renderOptionBar = getRenderOptionBar(renderOptionBar);
  var getDataSource = function getDataSource() {
    return dataSource || _dataSource;
  };
  ConfigProvider.config(_objectSpread({}, contextData));
  return /*#__PURE__*/React.createElement(ConfigProvider, _extends({
    locale: zhCN
  }, contextData), /*#__PURE__*/React.createElement(Provider, {
    value: initState
  }, /*#__PURE__*/React.createElement("div", {
    className: "super_table_warp",
    id: superTableWarpId
  }, search ? GenerAtorFrom(columns, form) : null, (_renderOptionBar$top = _renderOptionBar.top) === null || _renderOptionBar$top === void 0 ? void 0 : _renderOptionBar$top.call(_renderOptionBar, getTableInfo()), /*#__PURE__*/React.createElement("div", {
    className: "super_table_title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "super_table_title_left"
  }, (_renderOptionBar$cent = _renderOptionBar.center) === null || _renderOptionBar$cent === void 0 ? void 0 : _renderOptionBar$cent.call(_renderOptionBar, getTableInfo()))), (_renderOptionBar$bott = _renderOptionBar.bottom) === null || _renderOptionBar$bott === void 0 ? void 0 : _renderOptionBar$bott.call(_renderOptionBar, getTableInfo()), isShowSpace ? /*#__PURE__*/React.createElement("div", {
    className: "super_space"
  }) : null, /*#__PURE__*/React.createElement(Table, _extends({
    ref: tableRef
  }, reset, {
    components: {
      header: {
        wrapper: headerItemRender
      },
      body: {
        row: rowItemRender ? function (r) {
          var _getDataSource, _getDataSource2;
          if (!((_getDataSource = getDataSource()) !== null && _getDataSource !== void 0 && _getDataSource.length)) return r.children;
          var itemKey = r['data-row-key'];
          if (!itemKey) {}
          return rowItemRender((_getDataSource2 = getDataSource()) === null || _getDataSource2 === void 0 ? void 0 : _getDataSource2.find(function (i) {
            return i[rowKey] === itemKey;
          }));
        } : undefined
      }
    },
    rowKey: rowKey,
    columns: tableColumns,
    dataSource: getDataSource(),
    pagination: pagination && _objectSpread(_objectSpread({}, pageData.current), noCatchPageData)
  })), renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter())));
}
export default SuperTable;